import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const next = loc.state?.from || "/account";

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back");
      navigate(next);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="grid grid-cols-1 md:grid-cols-2 min-h-[80vh]" data-testid="login-page">
      <div className="hidden md:block overflow-hidden" style={{ background: "var(--line-soft)" }}>
        <img
          src="https://images.unsplash.com/photo-1714207427812-ef765d0e6a4c"
          alt="Tamoré"
          className="object-cover w-full h-full"
        />
      </div>
      <div className="flex items-center px-8 sm:px-16 py-20">
        <form className="w-full max-w-sm fade-up" onSubmit={submit}>
          <p className="tracking-overline text-[11px] uppercase opacity-60">Account</p>
          <h1 className="font-display text-5xl mt-4">Sign In.</h1>
          <p className="mt-4 opacity-70 text-sm">Welcome back to the atelier.</p>

          <div className="space-y-6 mt-12">
            <div>
              <label className="tm-label">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="tm-input"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="tm-label">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="tm-input"
                data-testid="login-password-input"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="btn-primary w-full mt-10"
            data-testid="login-submit-button"
          >
            {submitting ? "Signing in..." : "Enter"}
          </button>

          <p className="mt-8 text-sm opacity-70 text-center">
            New to TAMORÉ?{" "}
            <Link to="/register" className="underline underline-offset-4" data-testid="login-register-link">
              Create account
            </Link>
          </p>
        </form>
      </div>
    </main>
  );
}
